import { useEffect, useState } from "react";
import { dateObjectManagerClass } from "../ts/commonTools";

// hook이라는 특성상 초기에 실행되고난 후 새롭게 업데이트 되는 데이터로 다시 적용하기 위해선 내부의 hook을 넘겨주고 이것에 업데이트 시켜야한다.
const useDateString = (date_data: string | Date | null, custom_format_string?: string) => {
    const [originDateData, setOriginDateData] = useState<string | Date | null>(date_data);
    const [datetime, setDatetime] = useState<Date | null>(null);
    const [dateString, setDateString] = useState<string>("");

    const dateObjectManager = new dateObjectManagerClass();

    useEffect(() => {
        if(!!originDateData){
            let date_object: Date | null = null;

            if(originDateData instanceof Date){
                setDatetime(originDateData);
                date_object = originDateData;
            }else{
                const date_datetime = new Date(originDateData);
                if(isNaN(date_datetime.getTime())){
                    setDatetime(null);
                }else{
                    setDatetime(date_datetime);
                    date_object = date_datetime;
                }
            }

            if(date_object){
                if(!custom_format_string){
                    custom_format_string = "yyyy년 MM월 dd일";
                }

                setDateString(dateObjectManager.customFormatDate(date_object, custom_format_string));
            }
        }
    }, [originDateData, custom_format_string])

    return { datetime, dateString, setOriginDateData };
}

export default useDateString;